import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import TourImageSlider from "./TourImageSlider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getTourDetails, insertInquiry } from "./services/tour.services";
import { Helmet } from "react-helmet";
import { clearTourDetails } from "./tourSlice";
// import Select from "react-select";
import { IoIosMail, IoMdCall, IoMdCloud } from "react-icons/io";
import { BiSolidMessageDetail } from "react-icons/bi";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Loading from "../../components/spinner/Loading";
import { ErrorToast } from "../../toast/Toasts";
import { RiUser3Fill } from "react-icons/ri";
import FullLoading from "../../components/spinner/FullLoading";
import { formatIndianNumber } from "../../_helpers/formatUtils";

export const TourImageData = [
  { id: 1, image: "/images/detail-1.jpg" },
  { id: 2, image: "/images/detail-2.jpg" },
  { id: 3, image: "/images/detail-3.jpg" },
  { id: 4, image: "/images/detail-4.jpg" },
  { id: 5, image: "/images/detail-1.jpg" },
];

const TourDetailPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const TourURL = params?.TourURL;
  const TourID = location.state?.TourID;
  const NoOfNights = location.state?.NoOfNights;
  const RateType = location.state?.RateType;
  const RoomTypeID = location.state?.RoomTypeID;
  const fullURL = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;

  const tourLoading = useAppSelector((state) => state.tour.loading);
  // const contactLoading = useAppSelector((state) => state.contactUs.loading);
  const TourDetails = useAppSelector((state) => state.tour.TourDetails);

  useEffect(() => {
    const payload = {
      TourID: TourID ? +TourID : null,
      NoOfNights: NoOfNights ? `${NoOfNights}` : "",
      RateType: RateType ? RateType : "",
      RoomTypeID: RoomTypeID ? +RoomTypeID : null,
      TourURL: TourURL ? `${TourURL}` : "",
    };
    dispatch(getTourDetails(payload));
  }, [TourURL, TourID, NoOfNights, RateType, RoomTypeID]);

  useEffect(() => {
    return () => {
      dispatch(clearTourDetails());
    };
  }, []);

  const formik: any = useFormik({
    initialValues: {
      FirstName: "",
      LastName: "",
      EmailID: "",
      MobileNo: "",
      Remarks: "",
    },
    validateOnBlur: true,
    validationSchema: Yup.object({
      FirstName: Yup.string().trim().required("FirstName is required"),
      LastName: Yup.string().trim().required("LastName is required"),
      MobileNo: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9]{10}$/, "Mobile number is not valid"),
      EmailID: Yup.string()
        .required("Email is required")
        .test("is-email-required", "Email is not valid", function (value) {
          if (!value) {
            return true;
          }
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emailRegex.test(value);
        }),
    }),
    onSubmit: async (
      values,
      {
        // setSubmitting,
        resetForm,
      }
    ) => {
      const payload = {
        FirstName: values?.FirstName ? values?.FirstName : "",
        LastName: values?.LastName ? values?.LastName : "",
        EmailID: values?.EmailID ? values?.EmailID : "",
        MobileNo: `${values?.MobileNo}`,
        Remarks: values?.Remarks ? values?.Remarks : "",
        URL: TourDetails?.TourURL ? TourDetails?.TourURL : "",
      };
      const response = await dispatch(insertInquiry(payload));
      if (response.meta.requestStatus === "fulfilled") {
        navigate("/thankyou/");
        resetForm();
      } else {
        ErrorToast("Error sending message!");
      }
    },
  });

  return (
    <>
      {<FullLoading loading={tourLoading} />}
      <Helmet>
        <title>{TourDetails?.MetaTitle}</title>
        <meta name="description" content={TourDetails?.MetaDescription} />
        <meta name="keywords" content={TourDetails?.MetaKeywords} />
        <link rel="canonical" href={fullURL} />
      </Helmet>

      <div className="package-detail-banner">
        <div className="owl-carousel owl-theme popular-owl">
          <TourImageSlider
            data={
              TourDetails?.images || [
                { TourImage: "/images/newimages/NoImageFound.png" },
              ]
            }
          />
        </div>
      </div>
      <div className="tour-detail">
        <div className="detail-top">
          <div className="container">
            <div className="detail-heading">
              <h2>{TourDetails?.TourName}</h2>
              {/* <span className="location">
                <img src="/images/map-pin.png" alt="" />
                Main Street, Brooklyn, NY
              </span> */}
            </div>
            <div className="tour-facatity">
              <div className="facality-col">
                <img src="/images/clock.png" alt="" />
                <span>
                  <p>Duration</p>
                  <h5>
                    {TourDetails?.NoOfDays || 0} Days -{" "}
                    {TourDetails?.NoOfNights || 0} Nights
                  </h5>
                </span>
              </div>
              {/* <div className="facality-col">
                <img src="/images/users.png" alt="" />
                <span>
                  <p>Group Size</p>
                  <h5>1-15</h5>
                </span>
              </div> */}
              {TourDetails?.SeasonType && (
                <div className="facality-col">
                  <IoMdCloud style={{ fontSize: "32px", color: "#5b3d96" }} />
                  <span>
                    <p>Available in Season</p>
                    <h5>{TourDetails?.SeasonType}</h5>
                  </span>
                </div>
              )}
              {TourDetails?.tourspeciality &&
                TourDetails?.tourspeciality?.length > 0 && (
                  <div className="facality-col">
                    <img src="/images/Run-icon.png" alt="" />
                    <span>
                      <p>Tour Speciality</p>
                      <h5>
                        {TourDetails?.tourspeciality
                          ?.map((speciality: any) => speciality?.SpecialityType)
                          ?.join(", ")}
                      </h5>
                    </span>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="column-main">
            {/* <span className="package-rating">
              {" "}
              <img src="/images/star.png" alt="" />
              91 traveler reviews
            </span> */}
            <div className="row padd-40">
              <div className="col-lg-3 col-md-12 ">
                <div className="sidebar position-sticky " style={{ top: 100 }}>
                  <div className="sidebar-block user-form">
                    <form onSubmit={(e) => formik.handleSubmit(e)}>
                      <h3>Book this Tour</h3>
                      <div
                        className={`fields ${
                          formik.errors.FirstName && formik.touched.FirstName
                            ? "error-field"
                            : ""
                        }`}
                      >
                        <input
                          name="FirstName"
                          type="text"
                          placeholder="Enter Your First Name*"
                          maxLength={50}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values?.FirstName}
                        />
                        <RiUser3Fill />
                      </div>
                      <div
                        className={`fields ${
                          formik.errors.LastName && formik.touched.LastName
                            ? "error-field"
                            : ""
                        }`}
                      >
                        <input
                          name="LastName"
                          type="text"
                          placeholder="Enter Your Last Name*"
                          maxLength={50}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values?.LastName}
                        />
                        <RiUser3Fill />
                      </div>
                      <div
                        className={`fields ${
                          formik.errors.EmailID && formik.touched.EmailID
                            ? "error-field"
                            : ""
                        }`}
                      >
                        <input
                          type="email"
                          name="EmailID"
                          id="EmailID"
                          placeholder="Enter Your Email ID*"
                          maxLength={50}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values?.EmailID}
                        />
                        {/* <img src="/images/user.png" alt="" /> */}
                        <IoIosMail />
                      </div>
                      <div
                        className={`fields ${
                          formik.errors.MobileNo && formik.touched.MobileNo
                            ? "error-field"
                            : ""
                        }`}
                      >
                        <input
                          id="MobileNo"
                          name="MobileNo"
                          type="number"
                          placeholder="Enter Your Mobile No.*"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values?.MobileNo}
                          onInput={(e: any) => {
                            return (e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 10));
                          }}
                        />
                        <IoMdCall />
                      </div>
                      <div className={`fields`}>
                        <textarea
                          name="Remarks"
                          id="Remarks"
                          placeholder="Enter Your Message"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values?.Remarks}
                        />
                        <BiSolidMessageDetail />
                      </div>
                      {/* <div className="add-extra">
                        <h4>Add Extra: </h4>
                        <div className="ecter-right">
                          <div className="field">
                            <input type="checkbox" name="" id="" />
                            <label htmlFor="">Services per booking</label>
                          </div>
                          <div className="field">
                            <input type="checkbox" name="" id="" />
                            <label htmlFor="">Services per person</label>
                          </div>
                        </div>
                      </div> */}
                      {/* <span className="label">
                        {" "}
                        Adult: <span> $ 20,00</span>
                      </span>
                      <span className="label">
                        {" "}
                        Youth: <span> $ 16,00</span>
                      </span> */}

                      <input
                        className="fill-btn mt-2"
                        type="submit"
                        value={"Book Now"}
                      />
                    </form>
                  </div>
                  {TourDetails?.tourcost &&
                    TourDetails?.tourcost?.length > 0 && (
                      <div className="sidebar-block user-form m-0">
                        <div className="main-price text-end">
                          <h4 className="d-inline">
                            ₹{" "}
                            {formatIndianNumber(
                              +TourDetails?.tourcost?.[0]?.Rate || 0
                            )}
                          </h4>{" "}
                          {TourDetails?.tourcost?.[0]?.RateType}{" "}
                        </div>
                      </div>
                    )}
                  {/* <div className="map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.721417643294!2d77.29099611148352!3d28.608133075576696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5fec1616427%3A0xdcc5376cd87567dc!2sCostco%20Wholesaler!5e0!3m2!1sen!2sin!4v1755686891205!5m2!1sen!2sin"
                      width={600}
                      height={450}
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div> */}
                </div>
              </div>
              <div className="col-lg-9 col-md-12">
                <div className="details-column">
                  <div className="overview">
                    <h2>Overview</h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: TourDetails?.Overview,
                      }}
                    />
                  </div>
                  <div className="highlights padd-40">
                    <h2>Highlight List</h2>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: TourDetails?.TourInformation,
                      }}
                    />
                    {/* <ul>
                      <li>
                        Trek through rice terraces and explore the colorful
                        culture
                      </li>
                      <li>
                        Embark on an overnight cruise on the UNESCO Halong Bay
                      </li>
                      <li>
                        Discover the bustling "Pearl of the Orient" in Ho Chi
                        Minh
                      </li>
                      <li>
                        Explore the maze of waterways that is the Mekong Delta
                      </li>
                    </ul> */}
                  </div>
                  <div className="Amenities">
                    <h2>Tour Amenities</h2>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="Amenities-card Includes-card">
                          <h4>Includes</h4>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: TourDetails?.Inclusions,
                            }}
                          />
                          {/* <ul>
                            <li>Cruise Dinner &amp; Music Event</li>
                            <li>Pick and Drop Services</li>
                            <li>Additional Services</li>
                            <li>Specialized bilingual guide</li>
                            <li>Food and Drinks</li>
                          </ul> */}
                        </div>
                        {/* <div className="radius-10 img-effect">
                          <img src="/images/detail-col-1.png" alt="" />
                        </div> */}
                      </div>
                      <div className="col-md-6">
                        <div className="Amenities-card Excludes-card">
                          <h4>Excludes</h4>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: TourDetails?.Exclusions,
                            }}
                          />
                          {/* <ul>
                            <li>Cruise Dinner &amp; Music Event</li>
                            <li>Pick and Drop Services</li>
                            <li>Additional Services</li>
                            <li>Specialized bilingual guide</li>
                            <li>Food and Drinks</li>
                          </ul> */}
                        </div>
                        {/* <div className="radius-10 img-effect">
                          <img src="/images/detail-col-2.png" alt="" />
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="Itinerary padd-40">
                    <h2>Itinerary</h2>
                    <div className="accordion" id="accordionExample">
                      {TourDetails?.touritinerary &&
                        TourDetails?.touritinerary?.length > 0 &&
                        TourDetails?.touritinerary?.map(
                          (itinerary: any, index: number) => (
                            <div className="accordion-item" key={index}>
                              <h2
                                className="accordion-header"
                                id={`heading${index}`}
                              >
                                <button
                                  className={`accordion-button d-flex gap-2 align-items-baseline ${
                                    index === 0 ? "" : "collapsed"
                                  }`}
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#collapse${index}`}
                                  aria-expanded={index === 0 ? "true" : "false"}
                                  aria-controls={`collapse${index}`}
                                >
                                  <strong style={{ whiteSpace: "nowrap" }}>
                                    Day {itinerary?.ItineraryDay}:
                                  </strong>{" "}
                                  &nbsp;
                                  {itinerary?.ItineraryTitle}
                                </button>
                              </h2>
                              <div
                                id={`collapse${index}`}
                                className={`accordion-collapse collapse ${
                                  index === 0 ? "show" : ""
                                }`}
                                aria-labelledby={`heading${index}`}
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: itinerary?.ItineraryDescription,
                                    }}
                                  />
                                  {itinerary?.tourfcs &&
                                    itinerary?.tourfcs?.length > 0 && (
                                      <div
                                        className="d-flex column-gap-5 row-gap-2 p-2 flex-wrap mt-4"
                                        style={{ background: "whitesmoke" }}
                                      >
                                        {itinerary?.tourfcs?.map(
                                          (facility: any, index: number) => {
                                            return (
                                              <div
                                                key={index}
                                                className="d-flex gap-2 align-items-center"
                                              >
                                                <img src={facility?.Image} />
                                                {facility?.Name}
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          )
                        )}
                    </div>
                  </div>
                  {TourDetails?.CancellationPolicy && (
                    <div className="Cancellation-policy ">
                      <h2>Cancellation policy</h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: TourDetails?.CancellationPolicy,
                        }}
                      />
                    </div>
                  )}
                  {TourDetails?.TermsConditions && (
                    <div className="condition padd-40">
                      <h2>Terms &amp; Conditions</h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: TourDetails?.TermsConditions,
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="International-package padd-50 middle-btn">
              <div className="section-top">
                <h2>Related trips you might interested in</h2>
              </div>
              <div className="owl-carousel owl-theme popular-owl position-relative">
                {/* <InternationalPackagesSlider
                  data={TourDetails?.similarTour || []}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TourDetailPage;
